import { CoApplicantQuoteFormInput } from 'app/home/create-quote/forms/co-applicant/co-applicant.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function hasCoApplicantQuoteFormSelector(store: QuoteDraftSelectorState): CoApplicantQuoteFormInput {
  const hasCoApplicant = store.hasCoApplicant();
  return { hasCoApplicant };
}

export function hasCoApplicantQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['co-applicant']();
}
